"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

const theme = (0, _styles.createMuiTheme)({
  typography: {
    fontFamily: "Akkurat, sans-serif !important"
  },
  overrides: {
    MuiInputBase: {
      root: {
        fontFamily: "Akkurat, sans-serif !important",
        lineHeight: "1.25 !important"
      }
    },
    MuiFilledInput: {
      root: {
        //                backgroundColor: "rgba(255,255,255,0.9) !important",
        borderTopLeftRadius: "0 !important",
        borderTopRightRadius: "0 !important"
      }
    },
    MuiFormLabel: {
      root: {//                fontFamily: "Akkurat, sans-serif !important"
      }
    },
    MuiFormHelperText: {
      root: {//                fontFamily: "Akkurat, sans-serif !important"
      }
    }
  }
});
var _default = theme;
exports.default = _default;
module.exports = exports.default;